export default __webpack_public_path__ + "static/media/absorption-chiller.68ec01b1.jpg";